import Api from "~/service/Api";

class GuestRepository {
  validate(action, data) {
    return Api.post(`/guests/validate/${action}`, data);
  }
}

export default GuestRepository;
